import React, { useContext } from 'react';
import { Wws_SearchDomain } from '../../generated/graphql';
import { H2 } from '@xo-union/tk-ui-typography';
import { Footer } from '../FormComponents';

import { Formik, FieldProps, Field as FormikField } from 'formik';
import { RadioButton, SingleSelectGroup } from '@xo-union/tk-component-switches';
import { Body1 } from '@xo-union/tk-ui-typography';
import * as Yup from 'yup';
import { useMobileMedia } from '@xo-union/tk-ui-breakpoints';

import styles from './index.scss';
import { TrackingContext } from '../../TrackingContext';

interface Props {
  domainName: string;
  domains: Wws_SearchDomain[];
  onCancel: () => void;
  onSelect: (domain: string) => void;
}

const validationSchema = Yup.object().shape({
  domainName: Yup.string().required(),
});

interface InitialValues {
  domainName: string;
}

const SelectDomain: React.FC<Props> = ({ domainName, domains, onCancel, onSelect }) => {
  const { track } = useContext(TrackingContext);
  const mobileMedia = useMobileMedia();

  const initialValues = {
    domainName: domains[0]?.name,
  };

  const confirmDomain = (values: InitialValues) => {
    track('Custom WWS Domain Name Confirmation', { custom_domain_name: values.domainName });
    onSelect(values.domainName);
  };

  return (
    <>
      <div className={styles.header}>
        <H2 as="h1">Select your new domain</H2>
      </div>
      <div className={styles.subheader}>
        Here's what's available for <strong>{domainName.split('.')[0]}</strong>.
      </div>
      <div className={styles.formBody}>
        <Formik
          enableReinitialize
          validationSchema={validationSchema}
          initialValues={initialValues}
          onSubmit={confirmDomain}
        >
          {({ submitForm, setFieldValue }): JSX.Element => (
            <>
              <FormikField name="domainName">
                {({ field: { value } }: FieldProps) => (
                  <div className={styles.selectGroup}>
                    <SingleSelectGroup
                      value={value}
                      onChange={(evt: React.FormEvent<HTMLInputElement>): void => {
                        setFieldValue('domainName', evt.currentTarget.value);
                      }}
                    >
                      {domains.map(domain => (
                        <div className={styles.domainSelectRow} key={domain.name}>
                          <RadioButton value={domain.name} key={domain}>
                            <Body1>{domain.name}</Body1>
                          </RadioButton>
                          <span className={styles.priceColumn}>${domain.price}/yr</span>
                        </div>
                      ))}
                    </SingleSelectGroup>
                  </div>
                )}
              </FormikField>
              <Footer
                primaryOnClick={submitForm}
                primaryText="Check out"
                secondaryOnClick={onCancel}
                secondaryText="Start over"
                showSpinner={false}
                buttonsSize={mobileMedia.yes ? 'sm' : 'lg'}
                footerContainerClassOverride={styles.footerContainerClassOverride}
              />
            </>
          )}
        </Formik>
      </div>
    </>
  );
};

export default SelectDomain;
